import { NgModule } from '@angular/core';

import { CmpsCaAnalysisDialogModule } from '../dialog';
import { CmpsCaGuideDialogPickerModule } from '../guide-picker-dialog';

@NgModule({
    imports: [CmpsCaAnalysisDialogModule, CmpsCaGuideDialogPickerModule],
})
export class CmpsCaMeetModule {}
